export default __webpack_public_path__ + "static/media/Profile.4416e4d2.jpg";